import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Source, SourceService } from 'src/app/shared/services/source.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, NgForm } from '@angular/forms';
import { Region, RegionsService } from 'src/app/shared/services/regions.service';
import { Categorieslist, CategoriesService } from 'src/app/shared/services/categories.service';
import { CustomerNeed, CustomerNeedService } from 'src/app/shared/services/customer-need.service';
import { Product, ProductType, ProductsService } from 'src/app/shared/services/products.service';
import { sectorslist, SectorsService } from 'src/app/shared/services/sectors.service';
import { ProductitemService, ProductItem } from 'src/app/shared/services/productitem.service';
import { StatusService, statuslist } from 'src/app/shared/services/status.service';
import { Message } from 'primeng/api/message';
import { ConfirmationService } from 'primeng/api';
import { SalesService, Users, UserRole, UserPermissions, BrandLeadUser, ApplianceRole } from 'src/app/shared/services/sales.service';
import { SalesRep, SalesRepService } from 'src/app/shared/services/sales-rep.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-lookupmanagement',
  templateUrl: './lookupmanagement.component.html',
  styleUrls: ['./lookupmanagement.component.scss']
})
export class LookupmanagementComponent implements OnInit {


  displayCreationRow: boolean = false;
  displayStatusTable: boolean = false;
  displayRolesTable: boolean = false;
  displayProductTable: boolean = false;
  displaySalesRepTable: boolean = false;
  displayProductTypeTable : boolean = false;

  public rolesList: UserRole[] = new Array();
  public applianceRoleList: ApplianceRole[] = [];
  lookupColumnHeader: string;
  addRowClass: String = "addRowClass";
  sourceList: Source[] = [];
  lookupList: any[] = [];
  model: any = {};
  statusModel: any = {};
  updateModel: any = {};
  roleModel: any = {};
  productTypeModel: any = {};
  applianceRoleModel: any = {};
  productModel = {
    productType: '',
    productCategory: '',
    productItem: '',
    productKind: '',
    partNumber: '' ,
    isLicense: false
  };


  public statusBean: statuslist = new statuslist();
  public roleBean: UserRole = new UserRole();
  public applianceRoleBean: ApplianceRole;
  public productTypeBean: ProductType = new ProductType();
  salesRepBean: SalesRep = { name: '', phone: '', email: '' };
  editStatusId: number = -1;
  editRoleId: number = -1;
  editSalesRepId: number = -1;
  editeProductTypeId: number = -1;


  public regionsList: Region[] = [];
  public categorieslist: Categorieslist[] = [];
  public customerNeedList: CustomerNeed[] = [];
  public productTypeList: ProductType[] = [];
  public sectors: sectorslist[] = [];
  public items: ProductItem[] = [];
  public statusList: statuslist[] = [];
  productList: Product[] = [];
  msgs: Message[] = [];
  public salesRepList: SalesRep[] = [];
  public lookupObj = "";
  displayDialog = false;
  editId = -1;
  public errorMsg;
  editLookupBean: LookupBean = new LookupBean();

  selectedTab: String = 'Cadence';


  salesModel: SalesRep = { name: '', phone: '', email: '' };

  @ViewChild('f') f: NgForm;
  @ViewChild('statusForm') statusForm: NgForm;
  @ViewChild('updateForm') updateForm: NgForm;
  @ViewChild('roleForm') roleForm: NgForm;
  @ViewChild('ProductTypeForm') ProductTypeForm: NgForm;

  @ViewChild('SalesRepForm') salesRepForm: NgForm;
  @ViewChild("lookupSelectorEle", { static: true }) lookupSelectorEle: ElementRef;
  myRoleGroup: UntypedFormGroup;

  constructor(
    private salesService: SalesService,
    private sourceService: SourceService,
    private regionService: RegionsService,
    private sectorService: SectorsService,
    private productsService: ProductsService,
    private customerNeedService: CustomerNeedService,
    private categoriesService: CategoriesService,
    private itemService: ProductitemService,
    private statusService: StatusService,
    private confirmationService: ConfirmationService,
    private salesRepService: SalesRepService,
    private fb: UntypedFormBuilder
  ) {

    this.createForm();
  }

  async ngOnInit(): Promise<void> {
    $("body").css("overflow-y", "hidden");

    await this.loadLists();
    this.resetProductModel();

    $(".spinner-container").fadeOut();
    $("body").css("overflow-y", "auto");

  }

  createForm() {

    this.myRoleGroup = new UntypedFormGroup({
      userRole: new UntypedFormControl(null, [Validators.required]),
      userManagement: new UntypedFormControl(null, [Validators.required]),
      customerManagement: new UntypedFormControl(null, [Validators.required]),
      lookupManagement: new UntypedFormControl(null, [Validators.required]),
      techLeadAccess: new UntypedFormControl(null, [Validators.required]),
      product: new UntypedFormControl(null, [Validators.required]),
      // salesRep : new FormControl(null, [Validators.required])

      roleName: new UntypedFormControl(null, [Validators.required]),
      orderManagement: new UntypedFormControl(null, [Validators.required]),
      stockManagement: new UntypedFormControl(null, [Validators.required]),
      inventoryManagement: new UntypedFormControl(null, [Validators.required]),
      fileProcessingManagement: new UntypedFormControl(null, [Validators.required]),
      RFPManagement: new UntypedFormControl(null, [Validators.required]),
      prospectsManagement: new UntypedFormControl(null, [Validators.required]),
      accessLevel: new UntypedFormControl(null, [Validators.required]),
    });
  }
  async loadLists() {

    await this.sourceService.getSourceList().toPromise().then(response => { this.sourceList = response; });
    await this.regionService.getRegions().toPromise().then(response => { this.regionsList = response; }, error => this.errorMsg = error);
    await this.sectorService.retriveSectors().toPromise().then(response => { this.sectors = response; }, error => this.errorMsg = error);
    await this.statusService.getstatusList().toPromise().then(response => { this.statusList = response; }, error => this.errorMsg = error);
    await this.categoriesService.getCategoriesList().toPromise().then(response => { this.categorieslist = response; }, error => this.errorMsg = error);
    await this.itemService.getProductItems().toPromise().then(response => { this.items = response; }, error => this.errorMsg = error);
    await this.customerNeedService.getAllCustomerNeeds().toPromise().then(response => { this.customerNeedList = response; }, error => this.errorMsg = error);
    await this.productsService.getProductTypes().toPromise().then(response => { this.productTypeList = response; }, error => this.errorMsg = error);
    await this.salesService.retrieveAllRoles().toPromise().then(response => { this.rolesList = response; });
    await this.productsService.getProducts().toPromise().then(response => {
      this.productList = response;
      // console.log(this.productList);

    }, error => this.errorMsg = error);

    await this.salesRepService.getSalesRep().toPromise().then(response => { this.salesRepList = response; }, error => this.errorMsg = error);

    await this.salesService.retriveApplianceRoles().toPromise().then(response => {
      this.applianceRoleList = response;

      // console.log("Appliance Roles ", this.applianceRoleList);
    }, error => this.errorMsg = error);

  }

  // get Tab that Clicked
  onTabChange(event: any): void {
    const selectedTabHeader = event.originalEvent.target.textContent.trim();
    if (selectedTabHeader === 'Cadence Roles') {
      this.selectedTab = 'Cadence';
    } else if (selectedTabHeader === 'Appliance Roles') {
      this.selectedTab = 'Appliance';
    }
  }


  getApplianceRoleName(id: number): string {
    switch (id) {
      case 0:
        return "NO ACCESS";
      case 1:
        return "READ ONLY";
      case 2:
        return "UPDATE";
      case 3:
        return "FULL ACCESS";
      default:
        return "UNKNOWN";
    }
  }

  public onDropDownClicked(obj: any) {
    // console.log(obj);
    // console.log(obj.target.name);
    // console.log(obj.target.value);
    this.lookupColumnHeader = obj.target.value;
    this.lookupObj = obj.target.value;
    this.displayCreationRow = true;
    this.addRowClass = "addRowClass";
    this.lookupList = [];

    if (obj.target.value == "Select") {
      this.displayCreationRow = false;
    }

    if (obj.target.value == "Status") {
      this.displayStatusTable = true;
      this.displayRolesTable = false;
      this.displayCreationRow = false;
      this.displayProductTypeTable = false;
    }
    else if (obj.target.value == "Role") {
      this.displayStatusTable = false;
      this.displayRolesTable = true;
      this.displayCreationRow = false;
      this.displayProductTypeTable = false;
    }

    else {
      this.displayStatusTable = false;
      this.displayRolesTable = false;
      this.displayProductTypeTable = false;

    }
    if (obj.target.value == "Source") {
      // console.log(this.sourceList);
      this.sourceList.forEach((data, index) => {
        let dta = <Source>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.sourceId;
        lookupBean.name = dta.source;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "Sector") {

      this.sectors.forEach((data, index) => {
        let dta = <sectorslist>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.sectorId
        lookupBean.name = dta.sector;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "Region") {

      this.regionsList.forEach((data, index) => {
        let dta = <Region>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.regionId;
        lookupBean.name = dta.region;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "ProductType") {

      this.productTypeList.forEach((data, index) => {
        let dta = <ProductType>data;
        let lookupBean: ProductType = new ProductType();
        lookupBean.typeId = dta.typeId;
        lookupBean.productType = dta.productType;
        lookupBean.reorderLevel = dta.reorderLevel;
        lookupBean.reorderAvailable = dta.reorderAvailable;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "Item") {

      this.items.forEach((data, index) => {
        let dta = <ProductItem>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.itemId;
        lookupBean.name = dta.item;
        this.lookupList.push(lookupBean);
      });
    }


    if (obj.target.value == "Category") {

      this.categorieslist.forEach((data, index) => {
        let dta = <Categorieslist>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.categoryId;
        lookupBean.name = dta.category;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "CustomerNeed") {

      this.customerNeedList.forEach((data, index) => {
        let dta = <CustomerNeed>data;
        let lookupBean: LookupBean = new LookupBean();
        lookupBean.Id = dta.customerId;
        lookupBean.name = dta.customerNeed;
        this.lookupList.push(lookupBean);
      });
    }

    if (obj.target.value == "Product") {
      this.displayProductTable = true;
    } else {
      this.displayProductTable = false;
    }

    if (obj.target.value == "SalesRep") {
      this.displaySalesRepTable = true;
    } else {
      this.displaySalesRepTable = false;
    }

    if(obj.target.value == "ProductType"){
      this.displayProductTypeTable = true;
    }else{
      this.displayProductTypeTable = false;
    }




  }

  public deleteRow(event, id) {
    // console.log(event);
    // console.log(id);

    this.confirmationService.confirm({
      message: 'Do you want to delete?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.deleteLookup(id);
      },
      reject: () => { }
    });
  }

  public deleteLookup(Id: number) {
    if ("Source" == this.lookupObj) {
      this.sourceService.deleteSource(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Source deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Sector" == this.lookupObj) {
      this.sectorService.deleteSector(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Source deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Region" == this.lookupObj) {
      this.regionService.deleteRegion(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Region deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("CustomerNeed" == this.lookupObj) {
      this.customerNeedService.deleteCustomerNeed(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'CustomerNeed deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("ProductType" == this.lookupObj) {
      this.productsService.deleteProductType(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'ProductType deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Item" == this.lookupObj) {
      this.itemService.deleteProductItem(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Product Item deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Category" == this.lookupObj) {
      this.categoriesService.deleteCategory(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Category deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Status" == this.lookupObj) {

      this.statusService.deleteStatus(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Status deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
    else if ("Role" == this.lookupObj) {

      // console.log(this.lookupObj);

      if (this.selectedTab === 'Cadence') {

        this.salesService.deleteRole(Id).subscribe(
          (data) => {
            this.deleteLookupFromRow(Id);
            this.showMsg('info', 'Confirmed', 'Role deleted !!!');
          },
          (error) => {
            console.log(error);
            console.log(error.error);
            console.log(error.error.message);
            if (error.error.message.includes("ConstraintViolationException")) {
              this.showMsg('warning', 'Rejected', 'Cannot delete the Role!!!');
            }
            else {
              this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
            }
          });

      } else if (this.selectedTab === 'Appliance') {

        // console.log("id ", Id);
        this.salesService.deleteApplianceRole(Id).subscribe(
          (data) => {
            this.deleteLookupFromRow(Id);
            this.showMsg('info', 'Confirmed', 'Role deleted !!!');
          },
          (error) => {
            console.log(error);
            console.log(error.error);
            console.log(error.error.message);
            if (error.error.message.includes("ConstraintViolationException")) {
              this.showMsg('warning', 'Rejected', 'Cannot delete the Role!!!');
            }
            else {
              this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
            }
          });

      }

    }

    else if ("SalesRep" == this.lookupObj) {
      this.salesRepService.deleteSalesRep(Id).subscribe(
        (data) => {
          this.deleteLookupFromRow(Id);
          this.showMsg('info', 'Confirmed', 'Sales Rep deleted !!!');
        },
        (error) => {
          this.showMsg('warning', 'Rejected', 'Error happened while deleting!!!');
        });
    }
  }

  public deleteLookupFromRow(id: number) {
    var index = 0;
    if ("Source" == this.lookupObj) {
      for (var i = 0; this.sourceList; i++) {
        if (this.sourceList[i].sourceId == id) {
          index = i;
          break;
        }
      }
      this.sourceList = this.sourceList.slice(0, index).concat(this.sourceList.slice(index + 1));
    }
    else if ("Sector" == this.lookupObj) {
      for (var i = 0; this.sectors; i++) {
        if (this.sectors[i].sectorId == id) {
          index = i;
          break;
        }
      }
      this.sectors = this.sectors.slice(0, index).concat(this.sectors.slice(index + 1));
    }
    else if ("Region" == this.lookupObj) {

      for (var i = 0; this.regionsList; i++) {
        if (this.regionsList[i].regionId == id) {
          index = i;
          break;
        }
      }
      this.regionsList = this.regionsList.slice(0, index).concat(this.regionsList.slice(index + 1));

    }
    else if ("CustomerNeed" == this.lookupObj) {
      for (var i = 0; this.customerNeedList; i++) {
        if (this.customerNeedList[i].customerId == id) {
          index = i;
          break;
        }
      }
      this.customerNeedList = this.customerNeedList.slice(0, index).concat(this.customerNeedList.slice(index + 1));

    }
    else if ("ProductType" == this.lookupObj) {
      for (var i = 0; this.productTypeList; i++) {
        if (this.productTypeList[i].typeId == id) {
          index = i;
          break;
        }
      }
      this.productTypeList = this.productTypeList.slice(0, index).concat(this.productTypeList.slice(index + 1));

    }
    else if ("Item" == this.lookupObj) {
      for (var i = 0; this.items; i++) {
        if (this.items[i].itemId == id) {
          index = i;
          break;
        }
      }
      this.items = this.items.slice(0, index).concat(this.items.slice(index + 1));

    }
    else if ("Category" == this.lookupObj) {
      for (var i = 0; this.categorieslist; i++) {
        if (this.categorieslist[i].categoryId == id) {
          index = i;
          break;
        }
      }
      this.categorieslist = this.categorieslist.slice(0, index).concat(this.categorieslist.slice(index + 1));

    }
    else if ("Status" == this.lookupObj) {
      for (var i = 0; this.statusList; i++) {
        if (this.statusList[i].statusId == id) {
          index = i;
          break;
        }
      }
      this.statusList = this.statusList.slice(0, index).concat(this.statusList.slice(index + 1));

    }
    else if ("Role" == this.lookupObj) {

      if (this.selectedTab === 'Cadence') {
        for (var i = 0; this.rolesList; i++) {
          if (this.rolesList[i].roleId == id) {
            index = i;
            break;
          }
        }
        this.rolesList = this.rolesList.slice(0, index).concat(this.rolesList.slice(index + 1));

      } else if (this.selectedTab === 'Appliance') {
        for (var i = 0; this.applianceRoleList; i++) {
          if (this.applianceRoleList[i].roleId == id) {
            index = i;
            break;
          }
        }
        this.applianceRoleList = this.applianceRoleList.slice(0, index).concat(this.applianceRoleList.slice(index + 1));
      }

    }

    else if ("SalesRep" == this.lookupObj) {

      for (var i = 0; this.rolesList; i++) {
        if (this.rolesList[i].roleId == id) {
          index = i;
          break;
        }
      }
      this.salesRepList = this.salesRepList.slice(0, index).concat(this.salesRepList.slice(index + 1));
      this.refreshSalesRepList();
    }

    this.refreshList();
  }

  public closeCreationRow(event) {
    this.displayCreationRow = false;
  }

  public showAddRow(event, obj) {
    this.addRowClass = "";
    this.f.resetForm();
    this.statusForm.resetForm();
    this.roleForm.resetForm();
    this.salesRepForm.resetForm();
    this.ProductTypeForm.resetForm();
    this.roleBean = new UserRole();
  }

  public closeAddRow(event) {
    this.addRowClass = "addRowClass";
  
    this.resetProductModel();
  }

  resetProductModel() {
    this.productModel = {
      productType: '',
      productCategory: '',
      productItem: '',
      productKind: '',
      partNumber: '' ,
      isLicense: false
    };
  }


  public createLookup() {
    // console.log(`Creating Lookup form ${this.lookupObj}`);
    //let lookupObj = "";
    /*var lookupSelector =  <HTMLSelectElement>document.getElementById('lookupSelector');
        let options = lookupSelector.options;
        for (let index = 0; index < options.length; index++) {
          const element = options[index];
          //console.log(element);
          //console.log(element.selected);
          if (element.selected){
            console.log(element.value);
            this.lookupObj = element.value;
            break;
          }
        }*/

    if ("Source" == this.lookupObj) {
      let bean: Source = new Source();
      let sourceName = this.f.value;
      bean.source = sourceName.name;
      //console.log(sourceName.name);
      this.sourceService.createSource(bean).subscribe(
        async response => {
          //console.log("Create source : "+ response);
          //console.log(response);
          bean = response.data;
          // console.log(this.sourceList);
          this.sourceList.push(bean);
          // console.log(this.sourceList);
          this.refreshList();
          this.showMsg('info', 'Confirmed', 'Source Created Successfully !!!');
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );
    }
    else if ("Sector" == this.lookupObj) {
      let bean: sectorslist = new sectorslist();
      let values = this.f.value;
      bean.sector = values.name;
      //console.log(sourceName.name);
      this.sectorService.createSector(bean).subscribe(
        async response => {
          bean = response.data;
          this.sectors.push(bean);
          this.showMsg('info', 'Confirmed', 'Sector Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );

    }
    else if ("Region" == this.lookupObj) {

      let bean: Region = new Region();
      let values = this.f.value;
      bean.region = values.name;
      //console.log(sourceName.name);
      this.regionService.createRegion(bean).subscribe(
        async response => {
          bean = response.data;
          this.regionsList.push(bean);
          this.showMsg('info', 'Confirmed', 'Region Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );

    }
    else if ("CustomerNeed" == this.lookupObj) {

      let bean: CustomerNeed = new CustomerNeed();
      let values = this.f.value;
      bean.customerNeed = values.name;
      //console.log(sourceName.name);
      this.customerNeedService.createCustomerNeed(bean).subscribe(
        async response => {
          bean = response.data;
          this.customerNeedList.push(bean);
          this.showMsg('info', 'Confirmed', 'CustomerNeed Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );

    }
    else if ("ProductType" == this.lookupObj) {


      let bean: ProductType = new ProductType();
      let values = this.ProductTypeForm.value;
      bean.productType = values.productType;
      bean.reorderLevel = values.reorderLevel;
      bean.reorderAvailable = 0;
      //console.log(sourceName.name);
      this.productsService.createProductType(bean).subscribe(
        async response => {
          // console.log(response);
          bean = response.data;
          this.productTypeList.push(bean);
          this.showMsg('info', 'Confirmed', 'ProductType Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );

    }
    else if ("Item" == this.lookupObj) {

      let bean: ProductItem = new ProductItem();
      let values = this.f.value;
      bean.item = values.name;
      //console.log(sourceName.name);
      this.itemService.createProductItem(bean).subscribe(
        async response => {
          bean = response.data;
          this.items.push(bean);
          this.showMsg('info', 'Confirmed', 'ProductItem Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );
    }
    else if ("Category" == this.lookupObj) {

      let bean: Categorieslist = new Categorieslist();
      let values = this.f.value;
      bean.category = values.name;
      //console.log(sourceName.name);
      this.categoriesService.createCategory(bean).subscribe(
        async response => {
          bean = response.data;
          this.categorieslist.push(bean);
          this.showMsg('info', 'Confirmed', 'Category Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );
    }
    else if ("Status" == this.lookupObj) {
      let bean: statuslist = new statuslist();
      let values = this.statusForm.value;
      bean.status = values.status;
      bean.type = values.type;
      bean.odds = values.odds;
      // console.log(bean);
      this.statusService.createStatus(bean).subscribe(
        async response => {
          bean = response.data;
          this.statusList.push(bean);
          this.showMsg('info', 'Confirmed', 'Status Created Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );
    }
    else if ("Product" == this.lookupObj) {


      const product = {
        productTypeName: this.productModel.productType,
        productCategoryName: this.productModel.productCategory,
        productItemName: this.productModel.productItem,
        productKind: this.productModel.productKind,
        partNumber: this.productModel.partNumber ,
        isLicense: this.productModel.isLicense
      };

      this.productsService.createProductByName(product).subscribe(
        response => {
          // console.log('Product created successfully:', response);
          this.showMsg('info', 'Confirmed', 'Product Created Successfully !!!');
          this.refreshProductList();
        },
        error => {
          console.error('Error creating product:', error);
          this.showMsg('warning', 'Rejected', 'could not create a duplicate product');

        }

      );

      this.resetProductModel();

    }
    else if ("Role" == this.lookupObj) {


      if (this.selectedTab === 'Cadence') {

        let role: UserRole = new UserRole();
        let values = this.roleForm.value;
        role.roleId = -1;
        role.userRole = values.userRole;
        role.userManagement = values.userManagement;
        role.customerManagement = values.customerManagement;
        role.lookupManagement = values.lookupManagement;
        role.techLeadAccess = values.techLeadAccess;
        // console.log('inside create role.......');
        this.salesService.createRole(role).subscribe(
          async response => {
            this.roleBean = response.data;
            this.rolesList.push(role);
            this.showMsg('info', 'Confirmed', 'Role Created Successfully !!!');
            this.refreshList();
          },
          error => {
            this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
          }
        );


      } else if (this.selectedTab === 'Appliance') {
        let applianceRole: ApplianceRole = {} as ApplianceRole;
        let values = this.roleForm.value;
        applianceRole.roleId = null;
        applianceRole.orderManagement = values.orderManagement === 'true';
        applianceRole.stockManagement = values.stockManagement === 'true';
        applianceRole.inventoryManagement = values.inventoryManagement === 'true';
        applianceRole.fileProcessingManagement = values.fileProcessingManagement === 'true';
        applianceRole.RFPManagement = values.RFPManagement === 'true';
        applianceRole.prospectsManagement = values.prospectsManagement === 'true';
        
        applianceRole.roleName = values.roleName;
        applianceRole.accessLevel = parseInt(values.accessLevel, 10);

        // console.log("data ", applianceRole);
        this.salesService.createApplianceRole(applianceRole).subscribe(
          async response => {
            this.applianceRoleBean = response.data;
            this.applianceRoleList.push(applianceRole);
            this.showMsg('info', 'Confirmed', 'Role Created Successfully !!!');
            this.refreshList();
          },
          error => {
            this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
          }
        );
      }





    }


    else if ("SalesRep" == this.lookupObj) {
      let sales: SalesRep = {
        name: this.salesModel.name,
        phone: this.salesModel.phone,
        email: this.salesModel.email
      };

      // console.log("create ")
      this.salesRepService.addSalesRep(sales).subscribe(
        response => {
          this.salesRepList.push(response);
          this.showMsg('info', 'Confirmed', 'Sales Rep Created Successfully !!!');
          this.refreshList();
          this.refreshSalesRepList();
          this.resetSalesRepModel();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
        }
      );
    }


    this.addRowClass = "addRowClass";

  }
  resetSalesRepModel() {
    this.salesModel = { name: '', phone: '', email: '' };

  }

  public refreshList() {
    // console.log('refresh list called.....');
    (this.lookupSelectorEle.nativeElement as HTMLSelectElement).dispatchEvent(new Event("change"));
  }

  private refreshProductList() {
    this.productsService.getProducts().subscribe(
      response => {
        this.productList = response;
      },
      error => {
        console.error('Error fetching products:', error);
      }
    );
  }


  private refreshSalesRepList() {
    this.salesRepService.getSalesRep().subscribe(
      response => {
        this.salesRepList = response;
      },
      error => {
        console.error('Error fetching products:', error);
      }
    );
  }


  public showMsg(severity: string, summary: string, detail: string) {
    this.msgs = [{ severity: severity, summary: summary, detail: detail }];
    setTimeout(() => { this.msgs = [] }, 2000);
  }

  onSubmit(event) {
    // console.log(event);
    for (let controller in this.myRoleGroup.controls) {
      this.myRoleGroup.get(controller).markAsTouched();
    }

   console.log("event.submitter.id: ", event.submitter.id);

    if (event.submitter.id == "saveRole") {

      if (this.selectedTab === 'Cadence') {
        let isValid = this.cadenceFormValid();

        // console.log("Cadence isValid: ", isValid);
        if (isValid) {
          if (this.editRoleId != -1) {
            this.updateLookup(this.editRoleId);
          }
          else {
            this.createLookup();
          }

          // console.log("Role form is valid...");
        }
        else {
          // console.log("Role form is invalid");
        }

      } else if (this.selectedTab === 'Appliance') {
        let isValid = this.applianceFormValid();
        // console.log("Appliances isValid: ", isValid);
        if (isValid) {
          if (this.editRoleId != -1) {
            this.updateLookup(this.editRoleId);
          }
          else {
            this.createLookup();
          }
        } else {
          // console.log("Role form is invalid");
        }

      }
    }
    else if (event.submitter.id == "finish") {
      if (this.f.valid) {
        this.createLookup();
      }
      else {
        // console.log("form is invalid");
      }
    }
    else if (event.submitter.id == "saveProduct") {
      if (this.editRoleId != -1) {
        this.updateLookup(this.editRoleId);
      }
      else {
        this.createLookup();
      }
    }
    else if (event.submitter.id == "saveStatus") {

      if (this.statusForm.valid) {
        if (this.editStatusId != -1) {
          this.updateLookup(this.editStatusId);

        }
        else {
          this.createLookup();
        }

        // console.log("status form is valid...");
      }
      else {
        // console.log("status form is invalid");
      }

    }

    else if (event.submitter.id == "saveSales") {


      if (this.salesRepForm.valid) {
        if (this.editSalesRepId != -1) {
          this.updateLookup(this.editSalesRepId);

        }
        else {
          this.createLookup();
        }

        // console.log("SalesRep form is valid...");
      }
      else {
        // console.log("SalesRep form is invalid");
      }

    }else if (event.submitter.id == "saveProductType") {
      if (this.ProductTypeForm.valid) {
        if (this.editeProductTypeId != -1) {
          this.updateLookup(this.editeProductTypeId);
        }
        else {
          this.createLookup();
        }
      }
    } 
  }

  cadenceFormValid(): boolean {
    return this.myRoleGroup.controls.userRole.valid
      && this.myRoleGroup.controls.userManagement.valid
      && this.myRoleGroup.controls.customerManagement.valid
      && this.myRoleGroup.controls.lookupManagement.valid
      && this.myRoleGroup.controls.techLeadAccess.valid;
  }

  applianceFormValid(): boolean {
    return this.myRoleGroup.controls.roleName.valid
      && this.myRoleGroup.controls.orderManagement.valid
      && this.myRoleGroup.controls.stockManagement.valid
      && this.myRoleGroup.controls.inventoryManagement.valid
      && this.myRoleGroup.controls.fileProcessingManagement
      && this.myRoleGroup.controls.RFPManagement
      && this.myRoleGroup.controls.prospectsManagement
      && this.myRoleGroup.controls.accessLevel.valid;
  }



  modifyRole(event, id, type) {


    this.editRoleId = id;


    // console.log("edit role id: " + id);

    if (type === 'Cadence') {
      // console.log('cadence')
      this.rolesList.forEach(element => {
        if (element.roleId == id) {
          // console.log(element);
          this.roleBean = element;
          //console.log(this.roleBean);
        }
      });
      //console.log(this.roleBean);
      this.addRowClass = "";
      this.roleForm.resetForm(this.roleForm.value);
      this.roleModel.roleId = this.roleBean.roleId;
      this.roleModel.userRole = this.roleBean.userRole;
      this.roleModel.userManagement = this.roleBean.userManagement;
      this.roleModel.customerManagement = this.roleBean.customerManagement;
      this.roleModel.lookupManagement = this.roleBean.lookupManagement;
      this.roleModel.techLeadAccess = this.roleBean.techLeadAccess;

      this.myRoleGroup.controls.userRole.setValue(this.roleBean.userRole);
      this.myRoleGroup.controls.userManagement.setValue(this.roleBean.userManagement);
      this.myRoleGroup.controls.customerManagement.setValue(this.roleBean.customerManagement);
      this.myRoleGroup.controls.lookupManagement.setValue(this.roleBean.lookupManagement);
      this.myRoleGroup.controls.techLeadAccess.setValue(this.roleBean.techLeadAccess);
      /*role.roleId=-1;
      role.userRole="";
      role.userManagement = false;
      role.customerManagement = false;
      role.lookupManagement = false;*/
    }

    else if (type === 'Appliance') {

      // console.log('Appliance')
      this.applianceRoleList.forEach(element => {
        if (element.roleId == id) {
          this.applianceRoleBean = element;
          // console.log(this.applianceRoleBean);
        }
      });



      this.addRowClass = "";
      this.roleForm.resetForm(this.roleForm.value);
      this.applianceRoleModel.roleId = this.applianceRoleBean.roleId;
      this.applianceRoleModel.roleName = this.applianceRoleBean.roleName;
      this.applianceRoleModel.orderManagement = this.applianceRoleBean.orderManagement;
      this.applianceRoleModel.stockManagement = this.applianceRoleBean.stockManagement;
      this.applianceRoleModel.inventoryManagement = this.applianceRoleBean.inventoryManagement;
      this.applianceRoleModel.fileProcessingManagement = this.applianceRoleBean.fileProcessingManagement;
      this.applianceRoleModel.RFPManagement = this.applianceRoleBean.RFPManagement;
      this.applianceRoleModel.prospectsManagement = this.applianceRoleBean.prospectsManagement;
      this.applianceRoleModel.accessLevel = this.applianceRoleBean.accessLevel;

      this.myRoleGroup.controls.roleName.setValue(this.applianceRoleBean.roleName);
      this.myRoleGroup.controls.orderManagement.setValue(this.applianceRoleBean.orderManagement);
      this.myRoleGroup.controls.stockManagement.setValue(this.applianceRoleBean.stockManagement);
      this.myRoleGroup.controls.inventoryManagement.setValue(this.applianceRoleBean.inventoryManagement);
      this.myRoleGroup.controls.fileProcessingManagement.setValue(this.applianceRoleBean.fileProcessingManagement);
      this.myRoleGroup.controls.RFPManagement.setValue(this.applianceRoleBean.RFPManagement);
      this.myRoleGroup.controls.prospectsManagement.setValue(this.applianceRoleBean.prospectsManagement);
      this.myRoleGroup.controls.accessLevel.setValue(this.applianceRoleBean.accessLevel);


    }

  }

  modifyStatus(event, id) {
    // console.log("id: " + id);
    this.editStatusId = id;
    // console.log(this.statusList);
    this.statusList.forEach(element => {
      if (element.statusId == id) {
        this.statusBean = element;
      }
    });
    // console.log(this.statusBean);
    this.addRowClass = "";
    this.statusForm.resetForm(this.statusForm.value);
    this.statusModel.status = this.statusBean.status;
    this.statusModel.type = this.statusBean.type;
    this.statusModel.odds = this.statusBean.odds;
    // console.log(this.statusModel);
  }



  modifyProductType(event, id) {
    this.editeProductTypeId = id;
    this.productTypeList.forEach(element => {
      if (element.typeId == id) {
        this.productTypeBean = element;
      }
    });

    console.log("id" , id);

    console.log(this.productTypeBean);
    this.addRowClass = "";
    this.ProductTypeForm.resetForm(this.ProductTypeForm.value);
    this.productTypeModel.productType = this.productTypeBean.productType;
    this.productTypeModel.reorderLevel = this.productTypeBean.reorderLevel;
    this.productTypeModel.reorderAvailable = this.productTypeBean.reorderAvailable;
  }
  // modifySalesRep(event,id) {
  //   console.log("id: " + id);
  //   this.editSalesRepId = id;
  //   console.log(this.salesRepList);
  //   this.salesRepList.forEach(element => {
  //     if (element.id == id) {
  //       this.salesRepBean = element;
  //     }
  //   });

  //   this.addRowClass = "";
  //   this.salesRepForm.resetForm(this.salesRepForm.value);
  //   this.salesModel.name = this.salesRepBean.name;
  //   this.salesModel.phone = this.salesRepBean.phone;
  //   this.salesModel.email = this.salesRepBean.email;
  //   console.log(this.statusModel);

  // }

  modifySalesRep(event, id) {
    // console.log("id: " + id);
    this.editSalesRepId = id;

    // Find the selected sales rep in the list
    this.salesRepList.forEach(element => {
      if (element.id == id) {
        this.salesRepBean = element;
      }
    });

    // Set the model values from the selected sales rep
    this.salesModel.name = this.salesRepBean.name;
    this.salesModel.phone = this.salesRepBean.phone;
    this.salesModel.email = this.salesRepBean.email;

    // Reset the form while retaining the current model values
    this.salesRepForm.resetForm(this.salesModel);

    this.addRowClass = "";

    // console.log(this.salesModel);
  }



  editUserData(event, id) {
    this.displayDialog = true;
    this.editId = id;
    // console.log(" id :" + id);
    this.updateForm.resetForm(this.updateForm.value);
    this.updateModel.name = "Hello Mahboob";
    // console.log("this.lookupObj:" + this.lookupObj);
    // console.log(" this.updateModel.name: " + this.updateModel.name);
    //console.log(" : "+);

    if ("Source" == this.lookupObj) {
      for (var i = 0; this.sourceList; i++) {
        if (this.sourceList[i].sourceId == id) {
          this.updateModel.name = this.sourceList[i].source;
          break;
        }
      }
    }
    else if ("Sector" == this.lookupObj) {
      for (var i = 0; this.sectors; i++) {
        if (this.sectors[i].sectorId == id) {
          this.updateModel.name = this.sectors[i].sector;
          break;
        }
      }
    }
    else if ("Region" == this.lookupObj) {

      for (var i = 0; this.regionsList; i++) {
        if (this.regionsList[i].regionId == id) {
          this.updateModel.name = this.regionsList[i].region;
          break;
        }
      }
    }
    else if ("CustomerNeed" == this.lookupObj) {
      for (var i = 0; this.customerNeedList; i++) {
        if (this.customerNeedList[i].customerId == id) {
          this.updateModel.name = this.customerNeedList[i].customerNeed;
          break;
        }
      }

    }
    else if ("ProductType" == this.lookupObj) {
      for (var i = 0; this.productTypeList; i++) {
        if (this.productTypeList[i].typeId == id) {
          this.updateModel.name = this.productTypeList[i].productType;
          break;
        }
      }
    }
    else if ("Item" == this.lookupObj) {
      for (var i = 0; this.items; i++) {
        if (this.items[i].itemId == id) {
          this.updateModel.name = this.items[i].item;
          break;
        }
      }
    }
    else if ("Category" == this.lookupObj) {
      for (var i = 0; this.categorieslist; i++) {
        if (this.categorieslist[i].categoryId == id) {
          this.updateModel.name = this.categorieslist[i].category;
          break;
        }
      }
    }

    this.editLookupBean = new LookupBean();
    this.editLookupBean.name = this.updateModel.name;
    // console.log(" this.updateModel.name 123: " + this.updateModel.name);

  }


  closeUpdateDialog(event) {
    this.displayDialog = false;
  }

  public updateLookup(id) {

    if ("Source" == this.lookupObj) {
      let bean: Source = new Source();
      bean.sourceId = id;
      let sourceName = this.updateForm.value;
      bean.source = sourceName.name;
      this.sourceService.updateSource(bean).subscribe(
        async response => {
          await this.sourceService.getSourceList().toPromise().then(response => { this.sourceList = response; });
          this.refreshList();
          this.showMsg('info', 'Confirmed', 'Source Updated Successfully !!!');
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );
    }
    else if ("Sector" == this.lookupObj) {
      let bean: sectorslist = new sectorslist();
      bean.sectorId = id;
      let values = this.updateForm.value;
      bean.sector = values.name;
      this.sectorService.updateSector(bean).subscribe(
        async response => {
          await this.sectorService.retriveSectors().toPromise().then(response => { this.sectors = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'Sector Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );

    }
    else if ("Region" == this.lookupObj) {

      let bean: Region = new Region();
      bean.regionId = id;
      let values = this.updateForm.value;
      bean.region = values.name;
      this.regionService.updateRegion(bean).subscribe(
        async response => {
          await this.regionService.getRegions().toPromise().then(response => { this.regionsList = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'Region Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );

    }
    else if ("CustomerNeed" == this.lookupObj) {

      let bean: CustomerNeed = new CustomerNeed();
      bean.customerId = id;
      let values = this.updateForm.value;
      bean.customerNeed = values.name;
      //console.log(sourceName.name);
      this.customerNeedService.updateCustomerNeed(bean).subscribe(
        async response => {
          await this.customerNeedService.getAllCustomerNeeds().toPromise().then(response => { this.customerNeedList = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'CustomerNeed Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );

    }
    else if ("ProductType" == this.lookupObj) {

      let bean: ProductType = new ProductType();
      bean.typeId = id;
      let values = this.ProductTypeForm.value;
      console.log(" Values: " , values);
      bean.productType = values.productType;
      bean.reorderLevel = values.reorderLevel;
      bean.reorderAvailable = 0;
      this.productsService.updateProductType(bean).subscribe(
        async response => {
          await this.productsService.getProductTypes().toPromise().then(response => { this.productTypeList = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'ProductType Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );

    }
    else if ("Item" == this.lookupObj) {

      let bean: ProductItem = new ProductItem();
      bean.itemId = id;
      let values = this.updateForm.value;
      bean.item = values.name;
      this.itemService.updateProductItem(bean).subscribe(
        async response => {
          await this.itemService.getProductItems().toPromise().then(response => { this.items = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'ProductItem Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );
    }
    else if ("Category" == this.lookupObj) {

      let bean: Categorieslist = new Categorieslist();
      bean.categoryId = id;
      let values = this.updateForm.value;
      bean.category = values.name;
      this.categoriesService.updateCategory(bean).subscribe(
        async response => {
          await this.categoriesService.getCategoriesList().toPromise().then(response => { this.categorieslist = response; }, error => this.errorMsg = error);
          this.showMsg('info', 'Confirmed', 'Category Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );
    }
    else if ("Status" == this.lookupObj) {

      let bean: statuslist = new statuslist();
      let values = this.statusForm.value;
      bean.status = values.status;
      bean.type = values.type;
      bean.odds = values.odds;
      bean.statusId = this.editStatusId;
      // console.log(bean);
      this.statusService.updateStatus(bean).subscribe(
        async response => {
          await this.statusService.getstatusList().toPromise().then(response => { this.statusList = response; }, error => this.errorMsg = error);
          this.editStatusId = -1;
          this.showMsg('info', 'Confirmed', 'Status Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );

    }
    else if ("Role" == this.lookupObj) {
      if (this.selectedTab === 'Cadence') {
        let role: UserRole = new UserRole();
        // console.log('inside update role.......',);
        let values = this.roleForm.value;
        role.roleId = this.editRoleId;
        role.userRole = values.userRole;
        role.userManagement = values.userManagement;
        role.customerManagement = values.customerManagement;
        role.lookupManagement = values.lookupManagement;
        role.techLeadAccess = values.techLeadAccess;
        // console.log('inside update role.......');

        // console.log(role);
        this.salesService.updateRole(role).subscribe(
          async response => {
            await this.salesService.retrieveAllRoles().toPromise().then(response => { this.rolesList = response; });
            this.editRoleId = -1;
            this.showMsg('info', 'Confirmed', 'Role Updated Successfully !!!');
            this.refreshList();
          },
          error => {
            console.log(error);
            this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
          }
        );
      } else if (this.selectedTab === 'Appliance') {
        // console.log('Appliance', id);
        // console.log('Appliance', this.editRoleId);
        let applianceRole: ApplianceRole = {} as ApplianceRole;
        let values = this.roleForm.value;
        applianceRole.roleId = this.editRoleId;
        applianceRole.orderManagement = values.orderManagement === "true";
        applianceRole.stockManagement = values.stockManagement === "true";
        applianceRole.inventoryManagement = values.inventoryManagement === "true";
        applianceRole.fileProcessingManagement = values.fileProcessingManagement === "true";
        applianceRole.RFPManagement = values.RFPManagement === "true";
        applianceRole.prospectsManagement = values.prospectsManagement === "true" ; 
        applianceRole.roleName = values.roleName;
        applianceRole.accessLevel = values.accessLevel;

        // console.log("data ", applianceRole);
        this.salesService.updateApplianceRole(applianceRole).subscribe(
          async response => {
            await this.salesService.retriveApplianceRoles().toPromise().then(response => { this.applianceRoleList = response; });
            this.editRoleId = -1;
            this.showMsg('info', 'Confirmed', 'Role Created Successfully !!!');
            this.refreshList();
          },
          error => {
            this.showMsg('warning', 'Rejected', 'Error happened while Creation!!!');
          }
        );

      }

    }

    else if ("SalesRep" == this.lookupObj) {

      let sales: SalesRep = {
        id: id,
        name: this.salesModel.name,
        phone: this.salesModel.phone,
        email: this.salesModel.email
      };
      // console.log('inside update role.......');

      // console.log(sales);
      this.salesRepService.updateSalesRep(id, sales).subscribe(
        async response => {
          await this.salesRepService.getSalesRep().toPromise().then(response => { this.salesRepList = response; });
          this.editRoleId = -1;
          this.showMsg('info', 'Confirmed', 'Role Updated Successfully !!!');
          this.refreshList();
        },
        error => {
          console.log(error);
          this.showMsg('warning', 'Rejected', 'Error happened while Updation!!!');
        }
      );
    }


  }


  onUpdateSubmit(event) {

    // console.log("this.updateForm.valid : " + this.updateForm.valid);
    //console.log(this.myGroup.value);
    //debugger;

    if (event.submitter.id == "finish") {
      if (this.updateForm.valid) {
        // console.log("form is valid");

        if (this.editId != -1) {
          // console.log("edit user details ....");

          this.displayDialog = false;
          this.updateLookup(this.editId);
        }

      }
      else {
        // console.log("form is invalid");
      }
    }
  }


}


export class LookupBean {
  constructor() { }

  public Id: number;
  public name: string;

}


